import React from "react";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";
import "./Simplidistance.css";

const Simplidistance = () => {
  return (
    <section className="Simplidistance">
      <div className="container">
        <Main_heading_holder
          // heading="Profcyma Career Solutions For "
          spanHeading="Profcyma Career Solutions For Online & Distance Learning "
          //   subHeading="We are authorized academic partners with India's leading UGC-recognized universities, serving as their Online MBA Academic Advisors and guiding your journey every step of the way."
          headingType="h2"
        />

        <p>
          Profcyma Career Solutions LLP helps students and working professionals
          enroll in UGC-approved online and distance education programs from
          India's leading universities. Discover Online & Distance MBA, BBA,
          MCA, BCA, and many more career-focused programs with expert
          counseling, seamless admission support, and personalized guidance to
          help you achieve your academic and professional goals.
        </p>
      </div>
    </section>
  );
};

export default Simplidistance;
